/* Pau Pao · Ficha de producto: variantes, galería, conjunto, barra fija, avísame. */
(() => {
  const raiz = document.querySelector('[data-ficha]'); if (!raiz) return;
  const D = JSON.parse(document.querySelector('[data-ficha-json]').textContent);
  const form = raiz.querySelector('[data-ficha-form]');
  const $ = (s) => raiz.querySelector(s);
  const money = window.ppx.money;
  const num = (s) => String(s || '').trim().split(' ')[0].toLowerCase();
  const corta = (v) => { const m = String(v).match(/\(([^)]+)\)/); let t = (m ? m[1] : String(v)).toLowerCase().replace(/meses|mes/g, '').replace(/ a /g, '-').replace(/\s*-\s*/g, '-').trim(); return /\d/.test(t) ? t + ' m' : v; };

  const sel = () => { const o = []; raiz.querySelectorAll('[data-opt]:checked').forEach((i) => (o[+i.dataset.opt] = i.value)); return o; };
  const busca = (o) => D.variantes.find((v) => v.opts.every((x, i) => o[i] === undefined || o[i] === x));

  /* Galería */
  const pista = $('[data-pista]'), puntos = [...raiz.querySelectorAll('[data-puntos] button')], nTxt = $('[data-galeria-n]');
  const figs = pista ? [...pista.children] : [];
  if (pista && puntos.length) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > .6) { const i = figs.indexOf(e.target); puntos.forEach((b, j) => b.setAttribute('aria-current', j === i)); if (nTxt) nTxt.textContent = `${i + 1} / ${figs.length}`; } }), { root: pista, threshold: [.6] });
    figs.forEach((f) => io.observe(f));
    puntos.forEach((b, i) => b.addEventListener('click', () => pista.scrollTo({ left: figs[i].offsetLeft, behavior: 'smooth' })));
  }
  const irAMedia = (id) => {
    const f = figs.find((x) => x.dataset.media == id); if (!f) return;
    if (matchMedia('(min-width: 990px)').matches) { if (f.getBoundingClientRect().top < 0 || f.getBoundingClientRect().top > innerHeight) f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    else pista.scrollTo({ left: f.offsetLeft, behavior: 'smooth' });
  };

  /* Conjunto */
  const packCb = $('[data-pack-cb]'), packP = $('[data-pack-precio]'), packBox = $('[data-pack]');
  const pintaPack = (v) => {
    if (!D.pack || !packBox) return;
    const n = D.talla >= 0 ? num(v.opts[D.talla]) : '';
    const pa = D.pack.pareja[n], pk = D.pack.pack[n];
    const ok = v.ok && pa && pa.ok && pk && pk.ok;
    packBox.style.opacity = ok ? '' : '.5'; packCb.disabled = !ok; if (!ok) packCb.checked = false;
    if (!ok) { packP.innerHTML = '<span>No disponible en esta talla</span>'; return null; }
    const sep = v.precio + pa.precio;
    packP.innerHTML = `<strong>Conjunto ${money(pk.precio)}</strong>${sep > pk.precio ? `<s>${money(sep)}</s><em>Ahorras ${money(sep - pk.precio)}</em>` : ''}`;
    return pk;
  };

  /* Estado de la variante */
  const vid = $('[data-vid]'), precio = $('[data-precio]'), estado = $('[data-estado]'), btn = $('[data-add]'), avis = $('[data-avisame]');
  const fija = document.querySelector('[data-fija]'), fijaP = document.querySelector('[data-fija-precio]'), fijaB = document.querySelector('[data-fija-btn]');
  let actual = null;
  const pinta = (v, cambioColor) => {
    actual = v;
    raiz.querySelectorAll('[data-sel-txt]').forEach((e) => { const i = +e.dataset.selTxt; const val = sel()[i]; e.textContent = val ? '· ' + (i === D.talla ? corta(val) : val) : ''; });
    if (!v) { btn.disabled = true; btn.textContent = 'No disponible'; estado.innerHTML = ''; return; }
    vid.value = v.id;
    precio.innerHTML = `<span class="precio__actual">${money(v.precio)}</span>${v.antes > v.precio ? `<s class="precio__antes"><span class="vh">Antes </span>${money(v.antes)}</s>` : ''}`;
    if (fijaP) fijaP.textContent = money(v.precio);
    const pl = raiz.querySelector('[data-plazos]'); if (pl) pl.textContent = `o 3 pagos de ${money(Math.floor(v.precio / 3))} con PayPal`;
    if (v.ok) {
      const poco = v.stock !== null && v.stock > 0 && v.stock <= D.umbral;
      estado.className = 'estado' + (poco ? ' estado--poco' : '');
      estado.innerHTML = poco ? `<i></i>Quedan ${v.stock} en esta talla` : '<i></i>Disponible · sale en 24-48 h';
      btn.disabled = false; btn.textContent = `Añadir a la cesta · ${money(v.precio)}`; avis.hidden = true;
      if (fijaB) { fijaB.disabled = false; fijaB.textContent = 'Añadir'; }
    } else {
      estado.className = 'estado estado--no'; estado.innerHTML = '<i></i>Agotada en esta talla';
      btn.disabled = true; btn.textContent = 'Agotada'; avis.hidden = false;
      if (fijaB) { fijaB.textContent = 'Avísame'; }
    }
    const pk = pintaPack(v);
    if (pk && packCb.checked) btn.textContent = `Añadir conjunto · ${money(pk.precio)}`;
    if (cambioColor && v.media) irAMedia(v.media);
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    // «Combínalo con»: misma talla
    if (D.talla >= 0) { const n = num(v.opts[D.talla]); const mr = String(v.opts[D.talla]).match(/\(([^)]+)\)/); const r = mr ? mr[1].toLowerCase().replace(/meses|mes/g, '').replace(/ a /g, '-').replace(/\s*-\s*/g, '-').trim() : ''; raiz.querySelectorAll('.pieza select').forEach((s) => { const op = [...s.options]; const o = (r && op.find((x) => (x.dataset.n || '').includes(`|${r}|`))) || (!r && op.find((x) => (x.dataset.n || '').includes(`|${n}|`))); if (o) s.value = o.value; }); }
  };
  form.addEventListener('change', (e) => {
    if (e.target.matches('[data-opt]')) { const cambioColor = +e.target.dataset.opt !== D.talla; pinta(busca(sel()), cambioColor); ppx.track('ppx_variante', { variante: actual && actual.id, disponible: !!(actual && actual.ok) }); }
    if (e.target.matches('[data-pack-cb]')) pinta(actual, false);
  });

  /* Añadir */
  const anadir = async () => {
    if (!actual || !actual.ok) return;
    let items = [{ id: actual.id, quantity: 1 }];
    if (packCb && packCb.checked && D.pack) { const pk = D.pack.pack[num(actual.opts[D.talla])]; if (pk && pk.ok) { items = [{ id: pk.id, quantity: 1 }]; ppx.track('ppx_conjunto_anadido', { pack: pk.id }); } }
    btn.classList.add('is-loading'); fijaB && fijaB.classList.add('is-loading');
    try { await ppx.add(items); } catch (er) { ppx.toast(er.message); } finally { btn.classList.remove('is-loading'); fijaB && fijaB.classList.remove('is-loading'); }
  };
  form.addEventListener('submit', (e) => { if (e.target !== form) return; e.preventDefault(); e.stopImmediatePropagation(); anadir(); }, true);
  if (fijaB) fijaB.addEventListener('click', () => { if (actual && actual.ok) anadir(); else { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });

  /* Barra fija: aparece cuando el botón principal sale de pantalla */
  if (fija && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { const on = !e.isIntersecting && e.boundingClientRect.top < 0; fija.classList.toggle('is-on', on); fija.setAttribute('aria-hidden', !on); fijaB.tabIndex = on ? 0 : -1; }).observe(btn);
  }

  /* Avísame (Klaviyo Back in Stock, la misma cuenta que usa la web actual) */
  const avB = $('[data-avisame-btn]');
  avB && avB.addEventListener('click', async () => {
    const em = $('[data-avisame-email]').value.trim(); if (!/^\S+@\S+\.\S+$/.test(em)) { ppx.toast('Revisa el correo'); return; }
    avB.classList.add('is-loading');
    try {
      const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RXHr24', { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: em } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + actual.id } } } } }) });
      if (r.status >= 200 && r.status < 300) { $('[data-avisame-ok]').hidden = false; ppx.track('ppx_avisame', { variante: actual.id }); } else throw 0;
    } catch (e) { ppx.toast('No se ha podido guardar. Prueba otra vez.'); } finally { avB.classList.remove('is-loading'); }
  });

  pinta(D.variantes.find((v) => v.id == vid.value) || D.variantes[0], false);
})();
